
const READ_ONLY_BLOCKED = 'ServiFlex/Error/READ_ONLY_BLOCKED';

const initialState = { error: false, message: null, hide: true, showOk: true, type: 'error'};

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case READ_ONLY_BLOCKED:
            // New object identity on every dispatch so the Notificator can react to repeated blocks.
            return {
                ...state,
                error: true,
                message: 'read_only_mode',
                type: 'readOnly'
            };
        default:
            return state;
    }
}

export const isReadOnlyError = (error) => !!error && error.code === 'READ_ONLY';

export function readOnlyBlocked() {
    return { type: READ_ONLY_BLOCKED };
}
